module.exports = __webpack_public_path__ + "media/images/creator/monitor/kv-a1fc69d6fdc55e8b805c85201ba06a62.png";